import { useParams } from 'react-router-dom';
import { IdParams } from '../types/IdParams';
import { PlaylistEnum } from '../enum/PlaylistEnum';

const useTypePlayList = () => {
    const { id }: IdParams = useParams();

    /**
     *
     * @returns PlaylistEnum
     * This function determines the type of playlist based on the provided id parameter.
     */
    const handleTypePlayList = (): PlaylistEnum => {
        const params = id.trim().toUpperCase();

        switch (params) {
            case PlaylistEnum.SEMINARIO:
                return PlaylistEnum.SEMINARIO;
            case PlaylistEnum.PROMOVER_ALFABETIZACAO:
                return PlaylistEnum.PROMOVER_ALFABETIZACAO;
            default:
                return PlaylistEnum.NOT404;
        }
    };

    return { handleTypePlayList, id };
};

export default useTypePlayList;
